import API from 'services/TAPS_API/index';

export default function getSimplifaedDeductionsPdfName(statementId, eventType) {
  return API.request({
    method: 'GET',
    url: `/notification/1150117/state/${statementId}?eventType=${eventType}`,
  });
}
